import { extraFeature } from '~/constants/extraFeture'
import { getInfoRestaurant } from './getInfoRestaurant'
import { path } from '~/routes/path'
import { getURLCategory, getURLCategoryInIndexMenu } from './getEndpointMenu'

//Check chức năng homepage trong trường hợp đã lưu vào redux rồi.
export const isHomePage = () => {
  const extraFeatureList = getInfoRestaurant()?.extraFeatures || []

  return extraFeatureList.includes(extraFeature.homepage)
}

// Check chức năng Top Page (Introduction)
export const isTopPage = (extraFeatureList = []) => {
  const extraFeatureUpdated = extraFeatureList || []

  return extraFeatureUpdated.includes(extraFeature.topPage)
}

// Check home page dựa vào extra feature khi gọi api
export const isHomePageFeature = (extraFeatureList = []) => {
  const extraFeatureUpdated = extraFeatureList || []

  return extraFeatureUpdated.includes(extraFeature.homepage)
}

/**
 * Hàm xử lý check extra feature của nhà hàng sẽ trả về URL hợp lý
 * Nếu như có quền:
 * 1. Topage -> trả về url màn hình Introduction
 * 2. Homepage -> trả về url màn hình Home
 * 3. Trường hợp còn lại di chuyển đến màn hình Menu
 * 4. Nếu trong trường hợp quét qr code category -> Di chuyển thẳng đến màn hình Menu và cuộn tới category đó
 *
 * @param {Array} extraFeatureList // danh sách feature mà API trả về
 * @returns {string}
 */
export const getFirstScreenURL = (extraFeatureList = [], category_ID) => {
  const extraFeatures = extraFeatureList || []
  if (category_ID) return getURLCategory(category_ID)

  if (extraFeatures.includes(extraFeature.topPage)) return path.introduction

  if (extraFeatures.includes(extraFeature.homepage)) return path.home

  return path.indexMenu
}

/**
 * Hàm xử lý check extra feature của nhà hàng sẽ trả về URL hợp lý
 * Nếu như có quền:
 * 1. Topage -> trả về url màn hình Introduction
 * 2. Homepage -> trả về url màn hình Home
 * 3. Trường hợp còn lại di chuyển đến màn hình Menu
 * 4. Nếu trong trường hợp quét qr code category -> Di chuyển thẳng đến màn hình Menu và category đó được chọn sẵn
 *
 * @param {Array} extraFeatureList // danh sách feature mà API trả về
 * @returns {string}
 */
export const getFirstScreenURLTablet = (extraFeatureList = [], category_ID) => {
  const extraFeatures = extraFeatureList || []
  if (category_ID) return getURLCategoryInIndexMenu(category_ID)

  if (extraFeatures.includes(extraFeature.topPage)) return path.introduction

  if (extraFeatures.includes(extraFeature.homepage)) return path.homeTablet

  return path.indexMenuTablet
}

/**
 * Khi click vào home icon trên menu bar sẽ phải check quền.
 * Trường hợp có quền home page -> di chuyển đến màn hình home page
 * Trường hợp ngược lại di chuyển đến màn hình menu
 */
export const getURLFromHomeIcon = (extraFeatureList = []) => {
  const extraFeatures = extraFeatureList || []
  if (extraFeatures.includes(extraFeature.homepage)) return path.home

  return path.indexMenu
}

/**
 * Khi click vào home icon trên menu bar sẽ phải check quền.
 * Trường hợp có quền home page -> di chuyển đến màn hình home page tablet
 * Trường hợp ngược lại di chuyển đến màn hình menu tablet
 */
export const getURLFromHomeIconTablet = (extraFeatureList = []) => {
  const extraFeatures = extraFeatureList || []
  if (extraFeatures.includes(extraFeature.homepage)) return path.homeTablet

  return path.indexMenuTablet
}

// Check chức năng Menu Template có được setting hay không
export const isMenuTemplate = (extraFeatureList = []) => {
  const extraFeatureUpdated = extraFeatureList || []

  return extraFeatureUpdated.includes(extraFeature.menuTemplate)
}

// Check chức năng thanh toán online có được setting hay không
export const isOnlinePayment = (extraFeatureList = []) => {
  const extraFeatureUpdated = extraFeatureList || []

  return extraFeatureUpdated.includes(extraFeature.onlinePayment)
}

// Hàm check chức năng tách bàn có được setting hay không
export const isSeparateOrder = (extraFeatureList = []) => {
  const extraFeatureUpdated = extraFeatureList || []

  return extraFeatureUpdated.includes(extraFeature.separateOrder)
}

// Hàm check chức năng buffet menu có được setting hay không
export const isBuffetMenu = (extraFeatureList = []) => {
  const extraFeatureUpdated = extraFeatureList || []

  return extraFeatureUpdated.includes(extraFeature.buffetMenu)
}

// Hàm check chức năng recommend menu có được setting hay không
export const isRecommendMenuEnable = (extraFeatureList = []) => {
  const extraFeatureUpdated = extraFeatureList || []

  return extraFeatureUpdated.includes(extraFeature.recommendMenu)
}

// Hàm check chức năng topping image có được setting hay không
export const isToppingImageEnable = (extraFeatureList = []) => {
  const extraFeatureUpdated = extraFeatureList || []

  return extraFeatureUpdated.includes(extraFeature.toppingImage)
}

// Hàm kiểm tra chức năng ẩn nút cộng khi giá món ăn là 0
export const isHidePlusFoodEnable = (extraFeatureList = []) => {
  const extraFeatureUpdated = extraFeatureList || []

  return extraFeatureUpdated.includes(extraFeature.hideQuantityZeropricedDishes)
}

// Kiểm tra chức năng linkage food items có được cài đặt hay không
export const isLinkageFoodItemsEnable = (extraFeatureList = []) => {
  const extraFeatureUpdated = extraFeatureList || []

  return extraFeatureUpdated.includes(extraFeature.linkage_items)
}
